import {
  ActiveState,
  EntityState,
  EntityStore,
  StoreConfig,
} from '@datorama/akita';
import { Injectable } from '@angular/core';
import { TableColumn } from '../../../models/table-column';
import { TextKeys } from '../../../i18n/text-keys';
import { getTableColumns } from './material-catalogue-table-columns';
import { ExpensesCatalogueFilterOptionsModel } from '../../../models/expenses-catalogue/expenses-catalogue-filter-options.model';
import { MaterialCatalogueListItem } from 'src/app/core/models/client-models';

export interface MaterialCatalogueItemsState
  extends EntityState<MaterialCatalogueListItem, number>,
    ActiveState {
  page: number;
  pageSize: number;
  columns: TableColumn[];
  lastPage: boolean;
  filterOptions: ExpensesCatalogueFilterOptionsModel;
  filterValue: string;
  sortKey: string;
  sortDirection: string;
}

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'material-catalogue-items', idKey: 'materialCatalogueID' })
export class MaterialCatalogueItemsStore extends EntityStore<MaterialCatalogueItemsState> {
  constructor() {
    super({
      page: 0,
      pageSize: 50,
      lastPage: false,
      columns: getTableColumns(),
      filterOptions: {
        price: {
          name: TextKeys.items.price,
          selected: false,
        },
        unit: {
          name: TextKeys.items.unit,
          selected: false,
        },
        description: {
          name: TextKeys.expenses.name,
          selected: false,
        },
        description2: {
          name: TextKeys.expenses.description,
          selected: false,
        },
        number: {
          name: TextKeys.expenses.numberLong,
          selected: false,
        },
        quantity: {
          name: TextKeys.quantity.quantity,
          selected: false,
        },
      },
      filterValue: '',
    });
  }
}
